angular.module('bbl.module.impersonate.routing', [])
  .config(['$routeProvider', impersonateRoutingSetup]);

function impersonateRoutingSetup($routeProvider) {
  var resolveAuth = {
    profile: ["Auth", function(Auth) {
      return Auth.getProfile().then(function(response) {
        return response.data.profile;
      });
    }], permissions: ["Auth", "$q", function(Auth, $q) {
      return Auth.getPermission().then(function(response) {
        if(response.data.permission_level !== 3) {
          return $q.reject({ authenticated: false });
        }
        return response.data.permission_level;
      });
    }]
  };
  
  var viewAsRoute = {
    templateUrl: 'impersonate-template.html',
    controller: 'ImpersonateController',
    resolve: resolveAuth
  };

  $routeProvider.when('/users/view-as', viewAsRoute)
    .when('/users/view-as/:userid', viewAsRoute);
}


/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/impersonate/impersonate.routing.js
 ** module id = 407
 ** module chunks = 0
 **/